import {
  MigrationJourneyCoverageArea,
  MigrationJourneyCoverageSummary,
} from '@/types/model/migrationCoverage';

const roundPercentage = (value: number): number => {
  return Math.round(value * 10) / 10;
};

export const buildMigrationJourneyCoverageSummary = (
  areas: MigrationJourneyCoverageArea[],
): MigrationJourneyCoverageSummary => {
  const totalJourneys = areas.reduce((total, area) => total + area.totalJourneys, 0);
  const automatedJourneys = areas.reduce((total, area) => total + area.automatedJourneys, 0);
  const unitJourneys = areas.reduce((total, area) => total + area.unitJourneys, 0);
  const e2eJourneys = areas.reduce((total, area) => total + area.e2eJourneys, 0);

  return {
    totalJourneys,
    automatedJourneys,
    pendingJourneys: totalJourneys - automatedJourneys,
    unitJourneys,
    e2eJourneys,
    automatedPercentage: totalJourneys === 0 ? 0 : roundPercentage((automatedJourneys / totalJourneys) * 100),
    coveredAreas: areas.filter((area) => area.status === 'covered').length,
    inProgressAreas: areas.filter((area) => area.status === 'in-progress').length,
  };
};

export const formatCoverageStatus = (status: MigrationJourneyCoverageArea['status']): string => {
  if (status === 'covered') {
    return 'Covered';
  }

  if (status === 'in-progress') {
    return 'In progress';
  }

  return 'Not started';
};